<template>
    <div class="col-md-12 px-0 py-0 mt-3">
        <form class="form-horizontal">
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Titulo</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="title"
                        class="form-control"
                        placeholder="Titulo"
                    />
                    <span v-if="allerrors.title" :class="['show-error']">{{
                        allerrors.title[0]
                    }}</span>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Fecha inicio</label
                >
                <div class="col-md-9">
                    <date-picker
                        v-model="start"
                        type="date"
                        valueType="format"
                        :lang="lang"
                        format="YYYY-MM-DD"
                    ></date-picker>
                    <span v-if="allerrors.start" :class="['show-error']">{{
                        allerrors.start[0]
                    }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Fecha fin</label
                >
                <div class="col-md-9">
                    <date-picker
                        v-model="final"
                        type="date"
                        valueType="format"
                        :lang="lang"
                        format="YYYY-MM-DD"
                    ></date-picker>
                    <span v-if="allerrors.final" :class="['show-error']">{{
                        allerrors.final[0]
                    }}</span>
                </div>
            </div>

            <div class="form-group row">
                <label
                    class="col-md-3 form-control-label"
                    for="text-input"
                ></label>
                <div class="col-md-9">
                    <div id="fine-uploader-manual-trigger"></div>
                    <span v-if="allerrors.image" :class="['show-error']">{{
                        allerrors.image[0]
                    }}</span>
                    <a
                        v-if="image_path"
                        :href="image_path"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Ver imagen</a
                    >
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Alt image</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="text_image_alt"
                        class="form-control"
                        placeholder="Alt image"
                    />
                    <span
                        v-if="allerrors.text_image_alt"
                        :class="['show-error']"
                        >{{ allerrors.text_image_alt[0] }}</span
                    >
                </div>
            </div>

            <div class="modal-footer">
                <button
                    v-if="model_id == 0"
                    type="button"
                    @click="create()"
                    class="btn btn-primary"
                >
                    Agregar
                </button>
                <button
                    v-if="model_id > 0"
                    type="button"
                    @click="update()"
                    class="btn btn-primary"
                >
                    Actualizar
                </button>
            </div>
        </form>
        <template-uploader></template-uploader>
    </div>
</template>
<script>
import qq from "fine-uploader";
import "fine-uploader/fine-uploader/fine-uploader-new.min.css";
export default {
    props: {
        model_id: Number,
        parent_id: Number,
    },
    data() {
        return {
            action: "",
            start: null,
            final: null,
            title: null,
            image: null,
            text_image_alt: null,
            image_path: null,
            allerrors: {
                title: null,
                start: null,
                text_image_alt: null,
                image: null,
            },
            lang: {
                days: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
                months: [
                    "Ene",
                    "Feb",
                    "Mar",
                    "Abr",
                    "May",
                    "Jun",
                    "Jul",
                    "Ago",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dic",
                ],
                pickers: [
                    "next 7 days",
                    "next 30 days",
                    "previous 7 days",
                    "previous 30 days",
                ],
                placeholder: {
                    date: "Seleccione fecha",
                },
            },
        };
    },
    methods: {
        getModel() {
            let me = this;
            axios
                .get("/api/contests/activities/show/" + me.model_id)
                .then(function (response) {
                    me.title = response.data.model.title;
                    me.start = response.data.model.start;
                    me.final = response.data.model.final;
                    me.image = response.data.model.image;
                    me.text_image_alt = response.data.model.text_image_alt;
                    me.image_path = response.data.image_path;
                })
                .catch(function (error) {});
        },
        create() {
            let me = this;
            if (me.validForm()) {
                axios
                    .post(me.action, {
                        title: me.title,
                        start: me.start,
                        final: me.final,
                        image: me.image,
                        text_image_alt: me.text_image_alt,
                    })
                    .then(function (response) {
                        me.allerrors = [];
                        me.showActionSuccess("Creacion exitosa!");
                        me.$emit("change");
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        update() {
            let me = this;
            if (me.validForm()) {
                axios
                    .put(me.action, {
                        title: me.title,
                        start: me.start,
                        final: me.final,
                        image: me.image,
                        text_image_alt: me.text_image_alt,
                        contest_id: me.parent_id,
                    })
                    .then(function (response) {
                        me.image_path = response.data.image_path;
                        me.allerrors = [];
                        me.showActionSuccess("Actualizacion exitosa!");
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },

        validForm() {
            let me = this;
            let valid = true;

            if (!me.title) {
                me.allerrors.title = ["El campo título es obligatorio."];
                valid = false;
            } else if (me.title.length > 50) {
                me.allerrors.title = [
                    "El campo título debe tener máximo 50 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.title = [""];
            }

            if (!me.image) {
                me.allerrors.image = ["El campo imagen es obligatorio."];
                valid = false;
            }

            if (me.text_image_alt && me.text_image_alt.length > 190) {
                me.allerrors.text_image_alt = [
                    "El campo image alt debe tener máximo 190 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.text_image_alt = null;
            }

            if (!me.start) {
                me.allerrors.start = ["El campo fecha inicio es obligatorio."];
                valid = false;
            } else {
                me.allerrors.start = null;
            }
            return valid;
        },
        showActionSuccess(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: message,
            });
        },
        getUploadImageUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/upload-image`;
        },
        getDeleteFileUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/delete-file`;
        },
    },
    mounted() {
        let me = this;
        const authUserId = document.querySelector(
            'meta[name="x-user"]'
        ).content;
        if (me.model_id == 0) {
            me.action = `/api/contests/activities?contest_id=${me.parent_id}&key=${authUserId}`;
            new qq.FineUploader({
                element: document.getElementById(
                    "fine-uploader-manual-trigger"
                ),
                request: {
                    endpoint: this.getUploadImageUrl(),
                },
                deleteFile: {
                    enabled: true, // defaults to false
                    endpoint: this.getDeleteFileUrl(),
                },
                template: "qq-template-manual-trigger",
                validation: {
                    allowedExtensions: ["jpeg", "jpg", "png", "svg"],
                    itemLimit: 1,
                    sizeLimit: 20971520,
                },
                messages: {
                    noFilesError: "Seleccione una imagen.",
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success) {
                            me.allerrors["image"] = null;
                            me.image = response.path;
                        } else {
                            me.allerrors["image"] = ["Error en la imagen"];
                        }
                    },
                    onDeleteComplete: function (id, name, response) {
                        me.allerrors["image"] = null;
                        me.image = "";
                    },
                },
                multiple: false,
            });
        } else {
            this.getModel();
            me.action = "/api/contests/activities/update/" + me.model_id;
            new qq.FineUploader({
                element: document.getElementById(
                    "fine-uploader-manual-trigger"
                ),
                request: {
                    endpoint: this.getUploadImageUrl(),
                },
                template: "qq-template-manual-trigger",
                validation: {
                    allowedExtensions: ["jpeg", "jpg", "png", "svg"],
                    sizeLimit: 20971520,
                },
                messages: {
                    noFilesError: "Seleccione una imagen.",
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success) {
                            me.allerrors["image"] = null;
                            me.image = response.path;
                        } else {
                            me.allerrors["image"] = ["Error en la imagen"];
                        }
                    },
                },
                multiple: false,
            });
        }
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
</style>
